import styled from '@emotion/styled';

export default styled('section')`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  margin: -8px;

  min-width: 100%;
`;
